class RelatedProducts extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initializeBlazeSlider();
    }

    initializeBlazeSlider() {
        const blazeSlider = this.querySelector('.related-products__slider');

        if (!blazeSlider) return;

        const slider = new BlazeSlider(blazeSlider, {
            all: {
                transitionDuration: 300,
                transitionTimingFunction: 'cubic-bezier(0.45, 0.1, 0.45, 0.5)',
                slidesToShow: 1.75,
                slidesToScroll: 1,
                slideGap: 'clamp(1.6rem, 1.66667vw, 3.2rem)',
                loop: false,
            },
            '(min-width: 768px)': {
                slidesToShow: 3,
            },
            '(min-width: 1024px)': {
                slidesToShow: 4,
            },
            '(min-width: 1440px)': {
                slidesToShow: 5,
            }
        });

        const prevBtn = this.querySelector('.related-products__prev');
        const nextBtn = this.querySelector('.related-products__next');

        this.updateButtonStates(0, slider);

        if (prevBtn) {
            prevBtn.addEventListener('click', () => slider.prev());
        }
        
        if (nextBtn) {
            nextBtn.addEventListener('click', () => slider.next());
        }

        slider.onSlide((slide, firstVisibleSlide) => {
            this.updateButtonStates(slide, slider);
        });
    }

    updateButtonStates(currentSlide, slider) {
        const prevBtn = this.querySelector('.related-products__prev');
        const nextBtn = this.querySelector('.related-products__next');
        
        if (prevBtn && nextBtn) {
            if (currentSlide === 0) {
                prevBtn.setAttribute('disabled', 'true');
            } else {
                prevBtn.removeAttribute('disabled');
            }
            
            if (currentSlide >= slider.states.length - 1) {
                nextBtn.setAttribute('disabled', 'true');
            } else {
                nextBtn.removeAttribute('disabled');
            }
        }
    }
}

customElements.define('related-products', RelatedProducts);
